// Custom Cart functionality for Product Builders.

// Get Product Information.
async function getProductInfo(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch product data');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

// Prepare line item properties.
function lineItemProperties(dataLoad) {
  let lineItemProperties = {};

  // Iterate through each entry in the dataset.
  Object.values(dataLoad).forEach((item) => {
    // Get the key (e.g., "Bowls" or "Proteins")
    const [key, value] = Object.entries(item)[0];

    // Initialize the key if it doesn't exist in mergedData
    if (!lineItemProperties[key]) {
      lineItemProperties[key] = '';
    }

    // Append the value to the existing string, with proper formatting
    if (lineItemProperties[key] !== '') {
      lineItemProperties[key] += ', ';
    }
    lineItemProperties[key] += value;
  });

  return lineItemProperties;
}

// Update the Cart Items.
async function updateCartItems(orderQty) {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const cart = await response.json();
    const cartIcon = document.querySelector('#cart-icon-bubble .cart-count-bubble span:first-child');
    if (cartIcon) {
      // Update existing cart icon text
      cartIcon.innerText = cart.item_count;
    }
    else {
      // Create new cart icon with count
      const spanElement = document.createElement('span');
      spanElement.setAttribute('aria-hidden', 'true');
      spanElement.textContent = orderQty;

      const divElement = document.createElement('div');
      divElement.classList.add('cart-count-bubble');
      divElement.prepend(spanElement);

      const cartBubble = document.querySelector('#cart-icon-bubble .icon');
      if (cartBubble) {
        cartBubble.insertAdjacentElement('afterend', divElement);
      }
    }
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

// Add Items to Card.
async function addItemsToCard(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log(result);
    return result;
  } catch (error) {
    console.error('Error:', error);
    throw error; // Re-throw the error so the caller can also handle it
  }
}

// Custom Cart functionality for the Shopping Cart.

// CartManagerProductRemoval handles customized products.
class CartManagerProductRemoval {
  constructor() {
    this.init();
  }

  // Initialize event listeners
  init() {
    const removeButtons = document.querySelectorAll('cart-remove-button a.button');
    removeButtons.forEach(button => {
      button.addEventListener('click', (event) => this.handleRemoveButtonClick(event, button));
    })
  }

  // Handle Remove Button Click
  handleRemoveButtonClick(event, button) {
    event.preventDefault();

    const productHandle = productsHandle[0].pathname.split('/')[2]

    const productTypeToRemove = button.getAttribute('data-product-type');
    const variantId = button.getAttribute('data-variant-id');

    this.fetchCart()
      .then(cart => {
        const matchingItems = cart.items.filter(item => item.product_type === productTypeToRemove);

        if (matchingItems.length > 1) {
          const confirmRemoval = confirm(
            `There are other items of the same product type ("${productTypeToRemove}") in your cart. Are you sure you want to remove all items of this type?`
          );

          if (confirmRemoval) {
            this.removeAllItemsOfType(matchingItems);
          }
        }
        else {
          this.removeSingleItem(variantId);
        }
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Fetch current cart data
  fetchCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => {
        console.error('Error fetching cart data:', error);
        throw error;
      });
  }

  // Remove all items of a specific product type
  removeAllItemsOfType(items) {
    const updates = items.map(item => [item.key, 0]); // Prepare cart updates

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: Object.fromEntries(updates) }),
    })
      .then(response => response.json())
      .then(cart => {
        console.log('All matching items removed:', cart);
        window.location.reload(); // Reload to reflect cart updates
      })
      .catch(error => console.error('Error removing items:', error));
  }

  // Remove a single item by variant ID
  removeSingleItem(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    })
      .then(response => response.json())
      .then(cart => {
        console.log('Item removed successfully:', cart);
        window.location.reload(); // Reload to reflect cart updates
      })
      .catch(error => console.error('Error removing item:', error));
  }

}

// Instantiate the CartManager class
document.addEventListener('DOMContentLoaded', () => {
  // new CartManagerProductRemoval();
});
